export const CCPA_ANALYTICS = "hs_ccpa_analytics";
export const CCPA_MARKETING = 'hs_ccpa_marketing';
export const CCPA_PERSONALIZATION = 'hs_ccpa_personalization';
export const ACCESSIBILITY = "hs_accessibility";
